import { AuxiliumComponent } from "../auxilium-component";

export class FrameContent extends AuxiliumComponent {
	static observedAttributes = ["spacing"];

	constructor() {
		super();

		this.centred = this.hasAttribute("centred");
		this.spacing = this.getAttribute("spacing") ?? "";
	}

	parsedCallback() {
		this.appendChild(document.createElementWithContents("main", this.childNodes, { className: this.centred ? "container" : "frame__main", id: "mainContent" }));
	}
}